import React, { useState } from 'react';
const sortByIndex = (list) => {
    const result = Array.from(list);
    return result.sort((a, b) => {
        return a.index - b.index;
    });
};


const moveByIndex = (source, destination, index) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(index, 1);
    destClone.push(removed);
    const result = {
        source: sourceClone,
        target: destClone
    };
    return result;
};

const moveByIndexPosition = (source, destination, index, index2) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(index, 1);
    destClone.splice(index2, 0, removed);
    const result = {
        source: sourceClone,
        target: destClone
    };
    return result;
};

const changeIndex = (source, index, index2) => {
    const result = Array.from(source);
    const temp = result[index];
    result[index] = result[index2];
    result[index2] = temp;
    return result;
};

function allowDrop(ev) {
    ev.preventDefault();
}

function drag(ev) {
    ev.dataTransfer.setData("elementId", ev.target.id);
}

function SelectSortOrder({name, label, list, selectedList, onChange}) {

    const [items, setItems] = useState(list || []);
    const [selected, setSelected] = useState(selectedList || []);
    
    function drop(ev) {
        ev.preventDefault();
        var elementId = ev.dataTransfer.getData("elementId");
        var element = document.getElementById(elementId);
        var index = element.dataset.index;
        var parentId = element.dataset.parentId;
        if((parentId === ev.target.id) || ev.target.draggable){
            return;
        }
        moveItemToBotton(index, parentId);
    }
    
    function drop2(ev) {
        ev.preventDefault();
        var elementId = ev.dataTransfer.getData("elementId");
        var element = document.getElementById(elementId);
        var index = element.dataset.index;
        var parentId = element.dataset.parentId; 
        var tagetParentId = ev.target.dataset.parentId;
        var index2 = ev.target.dataset.index;
        if(parentId === 'droppable2' && tagetParentId === 'droppable') {
            moveItemToBotton(index,parentId);
        } else if(parentId === 'droppable' && tagetParentId === 'droppable2' ) {
            moveItemToItem(items, selected, index, index2);
        } else if(parentId === 'droppable2' && tagetParentId === 'droppable2' ) {
            changePosition(selected, index, index2);
        }
}

    const moveItemToBotton = (index, id) => {
        const source = id === 'droppable' ? items : selected;
        const target = id !== 'droppable' ? items : selected;
        const result = moveByIndex(source, target, index, id);
        const orderedItems = sortByIndex(id === 'droppable' ? result.source : result.target);
        const selectedItems = id !== 'droppable' ? result.source : result.target;
        setItems(orderedItems);
        setSelected(selectedItems);
        if(onChange){onChange({selected: selectedItems, unselected: orderedItems});}
    };

    const moveItemToItem = (source, target, index, index2) => {
        var result = moveByIndexPosition(source, target, index, index2);
        setItems(result.source);
        setSelected(result.target);
        if(onChange){onChange({selected: result.target , unselected: result.source});}
    };

    const changePosition = (list, index, index2) => {
        var result = changeIndex(list, index, index2);
        setSelected(result);
        if(onChange){onChange({selected: result, unselected: items});}
    };
    
    const onClick = (index, id) => {
        moveItemToBotton(index, id);
    };

    return (
        <div>
            <div className="row">
            <div className="col-sm-12">
                <label>{label}</label>
            </div>
            </div>
            <div className="row">
                <div className="col-sm-5">
                    <ul id="droppable" data-testid="droppable" className="list-unstyled item-list"  onDrop={drop} onDragOver={allowDrop}>
                        {items.map((item, index) => (
                            <li
                                onDrop={drop2}
                                onDragOver={allowDrop}
                                draggable="true"
                                onDragStart={drag}
                                key={item.id}
                                id={item.id}
                                data-index={index}
                                data-parent-id="droppable"                                
                                className="list-item"
                                onClick={() => onClick(index,'droppable')}>
                                {item.content}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="col-sm-2 text-center">
                    <div className="vertical-space"></div>
                    <div>
                        <span className="fa fa-sm fa-arrow-left"></span>
                    </div>
                    <div>
                        <span className="fa fa-sm fa-arrow-right"></span>
                    </div>
                </div>
                <div className="col-sm-5">
                    <ul id="droppable2" data-testid="droppable2" className="list-unstyled item-list" onDrop={drop} onDragOver={allowDrop}>
                            {selected.map((item, index) => (
                                <li
                                    onDrop={drop2}
                                    onDragOver={allowDrop}
                                    draggable="true"
                                    onDragStart={drag}
                                    key={item.id}
                                    id={item.id}
                                    data-index={index}
                                    data-parent-id="droppable2"
                                    className="list-item"
                                    onClick={() => onClick(index, 'droppable2')}>
                                    {item.content}
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        </div>
    );
    
}

export default SelectSortOrder;


